import React, { useEffect } from "react";
import "./Gurujis_Pravachan.css";
import Common_Title_3 from "../../common/common_components/Common_Title_3/Common_Title_3";
import Pravachan_Card from "./pravachan_card/Pravachan_Card";
import { useDispatch, useSelector } from "react-redux";
import { AllChants } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";

const Gurujis_Pravachan = () => {


  const dispatch = useDispatch();
  const chants = useSelector((state) => state.common.all_chants);

  useEffect(() => {
    dispatch(AllChants({ pod_status: true }));
  }, [dispatch]);


  return (
    <section className="Gurujis_Pravachan">
      <div className="container">
        <Common_Title_3 titleText="Pravachan Podcast" seelink={'/all-albums'} />

        <div className="main_content_div">
          <div className="row">
            {chants?.slice(0, 4)?.map((chant, index) => {
              return (
                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <Pravachan_Card
                    musicList={chants}
                    image={chant?.image}
                    name={chant?.name}
                    album={chant?.Chant_Type?.name}
                    music={chant}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gurujis_Pravachan;
